import React, { useRef, useState } from 'react';
import ReactDOM from 'react-dom';

interface MetricHeaderProps {
  label: string;
  description: string;
}

const MetricHeader: React.FC<MetricHeaderProps> = ({ label, description }) => {
  const triggerRef = useRef<HTMLSpanElement | null>(null);
  const [visible, setVisible] = useState(false);
  const [tooltipStyle, setTooltipStyle] = useState<{ left: number; top: number }>({
    left: 0,
    top: 0
  });

  const updatePosition = () => {
    const rect = triggerRef.current?.getBoundingClientRect();
    if (!rect) {
      return;
    }
    setTooltipStyle({
      left: rect.left + rect.width / 2,
      top: rect.top - 12
    });
  };

  const showTooltip = () => {
    updatePosition();
    setVisible(true);
  };

  const hideTooltip = () => {
    setVisible(false);
  };

  return (
    <span className="metric-header-cell">
      <span>{label}</span>
      <span
        ref={triggerRef}
        className="metric-help-trigger"
        tabIndex={0}
        aria-label={`${label} 指标说明`}
        onMouseEnter={showTooltip}
        onMouseLeave={hideTooltip}
        onFocus={showTooltip}
        onBlur={hideTooltip}
      >
        <span className="metric-help-icon" aria-hidden="true">
          i
        </span>
      </span>
      {visible && ReactDOM.createPortal(
        <span
          className="metric-tooltip metric-tooltip-portal"
          role="tooltip"
          style={{ left: tooltipStyle.left, top: tooltipStyle.top }}
        >
          {description}
        </span>,
        document.body
      )}
    </span>
  );
};

export default MetricHeader;
